import React, { PropsWithChildren, useEffect, useState } from "react";
import SecurityContext from "@contexts/security/SecurityContext";
import { UserData } from "@models/UserData";
import { retrieveTokens, retrieveUserData } from "@services/token";

export function SecurityProvider({ children }: PropsWithChildren) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<UserData | undefined>();

  const value = {
    isAuthenticated,
    user,
  };

  useEffect(() => {
    const tokens = retrieveTokens();
    const userData = retrieveUserData();

    setIsAuthenticated(!!tokens && !!userData);
    setUser(userData);
  }, []);

  return (
    <SecurityContext.Provider value={value}>
      {children}
    </SecurityContext.Provider>
  );
}
